/* eslint-disable import/no-extraneous-dependencies */
import React, { PropTypes } from 'react'
import ScrollTop from './ScrollTop'
import { ClientProfileDataWrapper, ClientProfileData } from 'components/easinsure/client-profile'
import { ClientProfileSideBar } from 'components/easinsure/client-profile/side-bar'
import Documents from './ClientDocuments'
import Grail from './Grail'
import styles from './client.scss'

const ClientProfile = ({ detail, documents, isModifyClient, main, activeId, ...props }) => (
	<Grail
		nav={
			<ClientProfileSideBar
				{...props}
				className={styles.clientProfileNav}
				clientName={main.name}
				activeId={activeId}
			/>
		}
		content={
			<ScrollTop className={styles.clientProfileNav}>
				<div className={styles.wrapper}>
					{!activeId && (
						<ClientProfileDataWrapper isModifyClient={isModifyClient}>
							<ClientProfileData main={main} data={detail}/>
						</ClientProfileDataWrapper>
					)}
					{activeId === 'files' && <Documents documents={documents}/>}
				</div>
			</ScrollTop>
		}
	/>
)
ClientProfile.propTypes = {
	detail: PropTypes.object,
	documents: PropTypes.array,
	isModifyClient: PropTypes.bool,
	main: PropTypes.object,
	activeId: PropTypes.string,
	onLinkClicked: PropTypes.func,
	isPhone: PropTypes.bool,
	isTablet: PropTypes.bool,
}

export default ClientProfile



// WEBPACK FOOTER //
// ./elements/ClientProfile.jsx